'use client';

import Dialog from '@/components/Dialog';
import Popup from '@/components/Popup';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useTranslations } from '@/i18n/use-translations';
import { useRouter } from 'next/navigation';
import { useContext } from 'react';

interface NoticeDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function NoticeDialog({ open, onClose }: NoticeDialogProps) {
  const t = useTranslations('track-order.notice');
  const router = useRouter();
  const { deviceType } = useContext(ResponsiveContext);
  const isWeb = deviceType === EPlatform.WEB;

  const handleContactUs = () => {
    router.push('/contact-zeelool');
    onClose();
  };

  const renderContent = () => (
    <div className="notice text-14 leading-[24px] text-gray-800 md:px-20 md:pb-8">
      <p className="mb-24">{t('intro')}</p>

      <div className="mb-24 space-y-2">
        <p>{t('situation1')}</p>
        <p>{t('situation2')}</p>
        <p>{t('situation3')}</p>
        <p>{t('situation4')}</p>
      </div>

      <p className="mb-4">
        {t.rich('contactPrompt', {
          contactLink: (chunks) => (
            <button
              onClick={handleContactUs}
              className="text-primary-purple underline cursor-pointer"
            >
              {chunks}
            </button>
          ),
        })}
      </p>
    </div>
  );

  if (isWeb) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        footer={null}
        closeOnClickOverlay={false}
        maxWidth="md"
        PaperProps={{
          sx: {
            width: isWeb ? '660px' : '90%',
            maxWidth: isWeb ? '660px' : '90%',
          },
        }}
      >
        {renderContent()}
      </Dialog>
    );
  }

  return (
    <Popup
      open={open}
      onClose={onClose}
      closeOnClickOverlay
      hideCloseIcon={false}
      position="bottom"
      height="64vh"
      title={''}
      showDivider={false}
      sx={{
        '& .popup-content': {
          paddingTop: '16px',
        },
      }}
    >
      {renderContent()}
    </Popup>
  );
}
